var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6094 30.0926L30.0969 25.0004L21.6094 19.9082V30.0926Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1937 0 0 11.1922 0 25C0 38.8078 11.1937 50 25 50C38.8063 50 50 38.8063 50 25C50 11.1937 38.8063 0 25 0ZM38.575 26.0953C38.575 28.4391 38.3031 30.7828 38.3031 30.7828C38.3031 30.7828 38.0375 32.7797 37.225 33.6562C36.1922 34.8094 35.0359 34.8156 34.5047 34.8844C30.7047 35.175 25 35.1844 25 35.1844C25 35.1844 17.9406 35.1156 15.7688 34.8938C15.1641 34.7734 13.8094 34.8078 12.775 33.6562C11.9609 32.7781 11.6969 30.7828 11.6969 30.7828C11.6969 30.7828 11.425 28.4406 11.425 26.0953V23.8984C11.425 21.5547 11.6969 19.2125 11.6969 19.2125C11.6969 19.2125 11.9625 17.2156 12.775 16.3359C13.8078 15.1812 14.9641 15.175 15.4953 15.1094C19.2937 14.8156 24.9937 14.8156 24.9937 14.8156H25.0063C25.0063 14.8156 30.7063 14.8156 34.5047 15.1094C35.0344 15.175 36.1922 15.1813 37.225 16.3344C38.0391 17.2141 38.3031 19.2109 38.3031 19.2109C38.3031 19.2109 38.575 21.5547 38.575 23.8984V26.0953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6a0f00cd54cc93334b9ed6d0626ae53d.svg";
export { ForwardRef as ReactComponent };